module.exports = __webpack_public_path__ + "img/scroll-top.png";